import { create } from 'zustand';

import type { NotificationKind } from '@/lib/api/generated/model';

/** One notification the stream announced, numbered in arrival order. */
export interface Arrival {
  id: string;
  kind: NotificationKind | null;
  seq: number;
}

/** Enough to count a long read's arrivals; older ones are long since shown. */
const MAX_KEPT = 200;

interface ArrivalStore {
  arrivals: Arrival[];
  /** The last arrival's number; a page remembers it to count what came after. */
  seq: number;
  push: (id: string, kind: NotificationKind | null) => void;
}

/**
 * New notifications as the stream announces them (spec 147 FR-007). The
 * notifications page counts those after it last loaded into "N new · Show"
 * instead of letting the list move under the reader.
 */
export const useArrivalStore = create<ArrivalStore>((set) => ({
  arrivals: [],
  seq: 0,
  push: (id, kind) => {
    set((state) => {
      const seq = state.seq + 1;
      return {
        seq,
        arrivals: [...state.arrivals, { id, kind, seq }].slice(-MAX_KEPT),
      };
    });
  },
}));
